export default __webpack_public_path__ + "static/media/uselu.90bce8b2.jpg";